import React from 'react';
import { connect } from 'react-redux';

import Button from '@components/button/Button.tsx';
import CustomHead from '@components/customHead/CustomHead.tsx';
import Icon from '@components/icon/Icon.tsx';
import MainPreview from '@components/public/mainPreview/MainPreview.tsx';
import { s } from '@functions/seo.ts';
import { StoreT } from '@global/types.ts';

import IndexI from './types.ts';

import meta from './static/meta.ts';

class PublicIndex extends React.Component<IndexI['props']> implements IndexI {
    parent: IndexI['parent'];

    constructor(props: IndexI['props']) {
        super(props);
        this.state = {};

        this.parent = React.createRef();
    }

    meta = meta;

    render() {
        const { windowIsLoad } = this.props;

        return (
            <>
                <CustomHead {...this.meta} />

                <div className="publicIndex _SECTION _PUBLIC">
                    <div className="publicIndex__back">
                        <MainPreview windowIsLoad={windowIsLoad} />
                    </div>
                    <div className="publicIndex__inner _INNER">
                        {!s() && (
                            <img
                                src={require('../../../../../media/logo.svg').default}
                                alt=""
                                className="publicIndex__logo _LOGO"
                            />
                        )}
                        <h1 className="publicIndex__title">
                            Поиск выгодных
                            <br />
                            грузоперевозок
                        </h1>
                        <p className="publicIndex__description">
                            Найдём самый выгодный маршрут <br />
                            в&nbsp;несколько кликов — для вас
                        </p>
                        <div className="publicIndex__button">
                            <Button pageName="public-order">
                                Заказать перевозку{' '}
                                <i className="_arrowNext">
                                    <Icon name="arrow-next" />
                                </i>
                            </Button>
                        </div>
                        <div className="publicIndex__rights">
                            © {new Date().getUTCFullYear()} — Livecargo, поиск выгодных перевозок
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

function mapStateToProps(state: StoreT) {
    return {
        windowIsLoad: state.windowIsLoad,
    };
}

export default connect(mapStateToProps)(PublicIndex);
